export default __webpack_public_path__ + "static/media/the-dancing-one.bffda4d4.png";